<template>
  <div>
    <modal
      :exibir="exibir"
      @fechar="fecharModal"
      :titulo="`Endereços de ${pessoaSelecionada.nome}`"
      :campos="$refs"
      id="modalVinculosEnderecos"
      tamanho="lg"
      ocultarRodape
    >
      <div v-if="!exibirForm">
        <div>
          <div v-if="!modoVisualizacao">
            <p>
              Ao editar os endereços de uma pessoa neste modal, é
              automaticamente atualizado os dados na ficha da pessoa escolhida,
              não sendo necessário ir até o perfil dela para editar.
            </p>
          </div>
          <b-table
            :empty-text="$t('GERAL.NENHUM_REGISTRO')"
            head-variant="light"
            :items="enderecos"
            :fields="campos"
            show-empty
            responsive
            striped
            hover
          >
            <template #cell(acoes)="item">
              <div class="flex">
                <b-dropdown variant="outline-default" :disabled="modoVisualizacao">
                  <b-dropdown-item @click="excluirEndereco(item.item)">
                    {{ $t('GERAL.EXCLUIR') }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="editar(item.item)">
                    {{ $t('GERAL.EDITAR') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </template>
          </b-table>
          <div class="d-flex space-between w-100 mt-4">
            <b-button variant="secondary" @click="fecharModal">{{
              $t('GERAL.FECHAR')
            }}</b-button>
            <b-button variant="primary" @click="abrirForm" v-if="!modoVisualizacao">
              Criar novo endereço
            </b-button>
          </div>
        </div>
      </div>
      <div v-else>
        <vinculos-enderecos-form
          :pessoaId="pessoaSelecionada.pessoaId"
          :endereco="enderecoSelecionado"
          @fechar="fecharForm"
          @atualizar="buscarPessoa()"
        />
      </div>
    </modal>
  </div>
</template>

<script>
//aux & helpers
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

//Services
import PessoaService from '@/common/services/pessoa/pessoa.service';

// components
import Modal from '@/components/modal/Modal.vue';
import VinculosEnderecosForm from '@/views/academico/matriculas/components/VinculosEnderecosForm.vue';

export default {
  components: {
    Modal,
    VinculosEnderecosForm,
  },
  props: {
    exibir: { type: Boolean, default: false },
    pessoaSelecionada: { type: Object, default: Object },
  },
  computed: {
    modoVisualizacao() {
      return this.$route.path.includes('visualizar');
    }
  },
  data() {
    return {
      campos: [
        {
          key: 'cep',
          label: this.$t('PESSOAS.CEP'),
        },
        {
          key: 'logradouro',
          label: this.$t('PESSOAS.LOGRADOURO'),
        },
        {
          key: 'numero',
          label: this.$t('PESSOAS.NUMERO'),
        },
        {
          key: 'complemento',
          label: this.$t('PESSOAS.COMPLEMENTO'),
        },
        {
          key: 'tipoEnderecoDescricao',
          label: this.$t('PESSOAS.TIPO_ENDERECO'),
        },
        {
          key: 'principal',
          label: this.$t('PESSOAS.ENDERECO_PRINCIPAL'),
          formatter: (value) => {
            return value ? 'Sim' : 'Não';
          },
        },
        {
          key: 'acoes',
          label: this.$t('GERAL.ACOES'),
        },
      ],
      enderecos: [],
      exibirForm: false,
      enderecoSelecionado: null,
    };
  },
  methods: {
    buscarPessoa() {
      this.$store.dispatch(START_LOADING);
      PessoaService.buscarPorId(this.pessoaSelecionada.pessoaId)
        .then(({ data }) => {
          this.enderecos = data.enderecos;
        })
        .catch((erro) => {
          this.fecharModal();
          mensagem.showErrors(erro);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    async excluirEndereco(endereco) {
      const respostaExclusao = await mensagem.confirmacao(
        null,
        this.$t('FINANCEIRO.CONFIRMAR_EXCLUIR_ENDERECO')
      );
      if (respostaExclusao.isConfirmed) {
        this.$store.dispatch(START_LOADING);
        PessoaService.removerEndereco(endereco.id)
          .then(() => {
            mensagem.sucesso(
              this.$t('GERAL.SUCESSO'),
              this.$t('PESSOAS.ENDERECO_EXCLUIDO')
            );
            this.buscarPessoa();
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      }
    },
    editar(endereco) {
      this.enderecoSelecionado = endereco;
      this.abrirForm();
    },
    abrirForm() {
      this.exibirForm = true;
    },
    fecharForm() {
      this.enderecoSelecionado = null;
      this.exibirForm = false;
    },
    fecharModal() {
      this.exibirForm = false;
      this.$emit('fechar');
    },
  },
  watch: {
    exibir(valor) {
      if (valor) {
        this.buscarPessoa();
      }
    },
  },
};
</script>
